import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Space,
  Steps,
  Result,
  Input,
  DatePicker,
  message,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useStepsForm } from "sunflower-antd";
import dayjs from "dayjs";

import { getMemberApi } from "../../../services/Member/MemberApis";

interface IModalProps {
  show: boolean;
  memberId: any;
  showModal: Function;
  handleAdd: Function;
  policyId: any;
}

const AddPaymentModal: React.FC<IModalProps> = ({
  show,
  memberId,
  showModal,
  handleAdd,
  policyId,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    getMemberApi(String(memberId))
      .then((res: any) => {
        form.setFieldsValue({
          Amount: res.data.TotalPremium,
        });
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, []);

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    stepsProps,
    formProps,
    submit,
    formLoading,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      setLoading(true);

      const response = await handleAdd(
        {
          ...values,
          // Send calendar date only so API stores SAST wall-clock midnight digits
          Date: values.Date
            ? dayjs(values.Date).format("YYYY-MM-DD")
            : undefined,
          Type: "Cash",
        },
        policyId
      );

      if (response.success) {
        setLoading(false);
        return true;
      }
      setErrorMsg(response.message);
      setLoading(false);
      return false;
    },
    total: 3,
  });

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    labelCol: { span: 0 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const formList: any = [
    <>
      <Form.Item name="Amount" label="Amount">
        <Input size="large" id="Amount" placeholder="Amount" disabled={false} />
      </Form.Item>
      <Form.Item
        label="Reference Number"
        name="Reference"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" id="Reference" placeholder="Reference Number" />
      </Form.Item>
      <Form.Item name="Note" label="Note">
        <TextArea size="large" id="Note" placeholder="Note" />
      </Form.Item>

      <Form.Item
        label="Payment For"
        name="Date"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <DatePicker
          id="Date"
          picker="month"
          placeholder="Select Month"
          size="large"
          style={{ width: "100%" }}
          format="MMMM YYYY"
          onChange={(val) => {
            if (val) {
              form.setFieldsValue({ Date: val.startOf("month") });
            }
          }}
        />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            loading={loading}
            style={{ marginBottom: 10 }}
            block
            size="large"
            onClick={() => {
              submit().then((result: any) => {
                if (result) {
                  gotoStep(current + 1);
                } else if (!result) {
                  gotoStep(current + 2);
                }
              });
            }}
          >
            Submit
          </Button>
        </Space>
      </Form.Item>
    </>,
  ];

  return (
    <Modal
      title="Add Cash Payment"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={900}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 900 }}>
            {formList[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully submitted.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title={errorMsg}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AddPaymentModal;
